import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]

import {
  useStore,
} from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavLogoWithText',
  setup(__props) {

const appStore = useStore.app;
const navStore = useStore.nav;

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    to: _unref(appStore).homeRoute,
    class: "mx-5 my-auto"
  }, {
    default: _withCtx(() => [
      (_unref(navStore).isLightTheme)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: require('@/assets/site-assets/logo-light-theme.png'),
            alt: "logo",
            class: "h-16"
          }, null, 8, _hoisted_1))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: require('@/assets/site-assets/logo-dark-theme.png'),
            alt: "logo",
            class: "h-16"
          }, null, 8, _hoisted_2))
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})